// 当前系统名称
// export const SYSTEM_NAME = 'TCMA-manage-org'
export const SYSTEM_NAME = 'TCMA'
// 多語言存儲localStorage字段key
// export const LOCAL_LANG_KEY_CLINIC = 'TCMA-manage-org-lang'
export const LOCAL_LANG_KEY_CLINIC = 'tcma-lang'

class CacheKey {
  static readonly TOKEN = `${SYSTEM_NAME}-token-key`
  static readonly CONFIG_LAYOUT = `${SYSTEM_NAME}-config-layout-key`
  static readonly SIDEBAR_STATUS = `${SYSTEM_NAME}-sidebar-status-key`
  static readonly ACTIVE_THEME_NAME = `${SYSTEM_NAME}-active-theme-name-key`
  static readonly CACHED_VIEWS = `${SYSTEM_NAME}-cached-views-key`
  static readonly VISITED_VIEWS = `${SYSTEM_NAME}-visited-views-key`
}

export default CacheKey
